/**
 * Audio mime types supported by nVoq.
 */
export const AudioMimeType = Object.freeze({
  pcm16khz: 'audio/pcm-16khz',
  pcm8khz: 'audio/pcm-8khz',
  ogg: 'audio/ogg',
  webm: 'audio/webm',
});

/**
 * Audio formats supported by nVoq.
 */
export const AudioFormat: {
  ogg: string;
  pcm16khz: string;
  pcm8khz: string;
  webm: string;
} = Object.keys(AudioMimeType).reduce(
  (acc, curr) => {
    // @ts-expect-error [EN-10263] - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<{ pcm16khz: "audio/pcm-16khz"; pcm8khz: "audio/pcm-8khz"; ogg: "audio/ogg"; webm: "audio/webm"; }>'.
    const [, audioFormat] = AudioMimeType[curr].split('/');
    // @ts-expect-error [EN-10263] - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ ogg: string; pcm16khz: string; pcm8khz: string; webm: string; }'.
    acc[curr] = audioFormat;
    return acc;
  },
  { ogg: '', pcm16khz: '', pcm8khz: '', webm: '' }
);
